import React, { useEffect, useState } from 'react'
import { axiosGetUnAuth } from '../../../utils/AxiosApi';
import moment from 'moment';

const DisplayAllNpCalendar = (props) => {

    const [academicYearVal, setAcademicYearVal] = useState();
    const [currentEngMonthEndVal, setCurrentEngMonthEndVal] = useState("");
    const [npCalendarData, setNpCalendarData] = useState({});
    const [uniqueCalendarEvents, setUniqueCalendarEvents] = useState([]);
    const [currentMonthVal, setCurrentMonthVal] = useState("");
    const [currentYearVal, setCurrentYearVal] = useState("");
    const [currentEngYearVal, setCurrentEngYearVal] = useState("");
    const [currentEngMonthVal, setCurrentEngMonthVal] = useState("");

    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        if (props?.currentAcYr) {
            let academicYear = props?.currentAcYr?.academicYearName ? props?.currentAcYr?.academicYearName : props?.currentAcYr?.name;
            let academicYearVal = parseInt(academicYear?.split("(")[0].split("Academic Year ")[1]);
            setAcademicYearVal(academicYearVal);
            const fetchCalendarData = async () => {
                for (let i = 1; i <= 12; i++) {
                    await axiosGetUnAuth(`https://calendar.techarttrekkies.com.np/${academicYearVal}/${i}/json`, (resp) => {
                        if (resp) {
                            const nepaliCalendarData = resp?.data?.calendarData;
                            if (nepaliCalendarData && nepaliCalendarData?.length > 0) {
                                setNpCalendarData((prevData) => ({ ...prevData, [`month${i}`]: nepaliCalendarData }));

                            }
                        }
                    });
                }
            };
            fetchCalendarData();
        }
    }, [props]);


    useEffect(() => {
        if (npCalendarData?.length > 0) {
            setCurrentYearVal(npCalendarData?.[0]?.unicode?.bs_y)
            setCurrentMonthVal(npCalendarData?.[0]?.unicode?.month_name)
            setCurrentEngYearVal(npCalendarData?.[0]?.ad_y)
            setCurrentEngMonthVal(npCalendarData?.[0]?.month_name)
        }
    }, [npCalendarData]);

    const weekdayToIndex = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
    };

    const blanksCount = npCalendarData && npCalendarData.length > 0
        ? weekdayToIndex[npCalendarData[0].week_day] || 0
        : 0;

    const dayMapping = {};
    Object.keys(npCalendarData).forEach((month) => {
        npCalendarData[month].forEach((day) => {
            dayMapping[day.week_day] = day.unicode.week_day;
        });
    });

    const daysOfWeek = [
        { key: 'sunday', name: 'Sunday', shortName: 'Sun', nepaliDay: dayMapping['Sunday'], shortNepaliDay: 'आइत' },
        { key: 'monday', name: 'Monday', shortName: 'Mon', nepaliDay: dayMapping['Monday'], shortNepaliDay: 'सोम' },
        { key: 'tuesday', name: 'Tuesday', shortName: 'Tue', nepaliDay: dayMapping['Tuesday'], shortNepaliDay: 'मङ्ग' },
        { key: 'wednesday', name: 'Wednesday', shortName: 'Wed', nepaliDay: dayMapping['Wednesday'], shortNepaliDay: 'बुध' },
        { key: 'thursday', name: 'Thursday', shortName: 'Thu', nepaliDay: dayMapping['Thursday'], shortNepaliDay: 'बिहि' },
        { key: 'friday', name: 'Friday', shortName: 'Fri', nepaliDay: dayMapping['Friday'], shortNepaliDay: 'शुक्र' },
        { key: 'saturday', name: 'Saturday', shortName: 'Sat', nepaliDay: dayMapping['Saturday'], shortNepaliDay: 'शनि' },
    ];

    const weeks = [];
    let currentWeek = new Array(blanksCount).fill(null);
    Object.keys(npCalendarData).forEach((month) => {
        npCalendarData[month].forEach((day) => {
            currentWeek.push(day);
            if (currentWeek.length === 7) {
                weeks.push(currentWeek);
                currentWeek = [];
            }
        });
    });
    // Push last week if it has days but is incomplete
    if (currentWeek.length > 0) {
        while (currentWeek.length < 7) {
            currentWeek.push(null);
        }
        weeks.push(currentWeek);
    }

    const monthValues = {
        'month1': "बैसाख",
        'month2': "जेष्ठ",
        'month3': "असार",
        'month4': "श्रावण",
        'month5': "भाद्र",
        'month6': "आश्विन",
        'month7': "कार्तिक",
        'month8': "मंसिर",
        'month9': "पौष",
        'month10': "माघ",
        'month11': "फाल्गुन",
        'month12': "चैत्र",
    }

    const engMonthValues = {
        '1': "January",
        '2': "February",
        '3': "March",
        '4': "April",
        '5': "May",
        '6': "June",
        '7': "July",
        '8': "August",
        '9': "September",
        '10': "October",
        '11': "November",
        '12': "December",
    }

    const devanagariDigits = {
        '0': '०',
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
    };

    const renderNepaliMonthName = (month) => {
        let monthval = monthValues[month];
        let yearValueIni = academicYearVal?.toString();
        
        let monthValEngStart = engMonthValues[npCalendarData[month]?.[0]?.ad_m];
        let monthValEngEnd = engMonthValues[npCalendarData[month]?.[npCalendarData[month]?.length - 1]?.ad_m];

        
        let yearValEng = npCalendarData[month]?.[0]?.ad_y;
        let yearValue = yearValueIni?.split('').map((digit) => devanagariDigits[digit]).join('');

        const nextEngYear = parseInt(yearValEng) + 1;

        const nepaliMonthYearNpHeader = monthValEngStart === 'December' && monthValEngEnd === 'January'
        ? `${monthValEngStart} - ${monthValEngEnd},  ${yearValEng} / ${nextEngYear}`
        : `${monthValEngStart} - ${monthValEngEnd}, ${yearValEng}`;
        return (
            <>
                <div className='d-flex align-items-center justify-content-around flex-column'>
                    <h4 className="text-center mb-1"
                        style={{ fontFamily: "'NepaliFont', Arial" }}
                    >
                        {monthval} {yearValue}
                    </h4>
                    <h6 className="text-center mb-1"
                        style={{ fontFamily: "'NepaliFont', Arial" }}>
                          {nepaliMonthYearNpHeader}
                    </h6>
                </div>
            </>
        )
        // ;
    }

    return (
        <>
           
            <div className='tt-displayDate d-flex flex-wrap'
                style={{
                    height: "auto",
                    overflowY: "visible",
                    justifyContent: "space-evenly",
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gridGap: "10px"
                }}
            >
                {Object.keys(npCalendarData).sort((a, b) => parseInt(a.replace('month', '')) - parseInt(b.replace('month', ''))).map((monthKey, index) => {
                    const monthData = npCalendarData[monthKey];

                    // Calculate blanksCount for the current month
                    const blanksCount = monthData && monthData.length > 0
                        ? weekdayToIndex[monthData[0].week_day] || 0
                        : 0;

                    // Construct weeks for the current month
                    const weeks = [];
                    let currentWeek = new Array(blanksCount).fill(null); // Fill with blanks for the start of the month
                    monthData.forEach((day) => {
                        currentWeek.push(day);
                        if (currentWeek.length === 7) {
                            weeks.push(currentWeek);
                            currentWeek = [];
                        }
                    });
                    // Push last week if it has days but is incomplete
                    if (currentWeek.length > 0) {
                        while (currentWeek.length < 7) {
                            currentWeek.push(null);
                        }
                        weeks.push(currentWeek);
                    }

                    return (
                        <div
                            key={index}
                            className='tt-widgetContent-tab-holder allCalendarDisplay m-3'
                            style={{
                                backgroundColor: "#fff",
                                padding: "0px",
                                borderRadius: "10px",
                                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                                width: "385px"
                            }}
                        >
                            {renderNepaliMonthName(monthKey)}
                            <table className="table table-bordered" role="grid" aria-label="Nepali Calendar">
                                <thead>
                                    <tr className="text-white" style={{ fontSize: "1.5vh" }}>
                                        {daysOfWeek.map((day) => (
                                            <th
                                                key={day.key}
                                                scope="col"
                                                className="p-1 text-center"
                                            >
                                                <div>{day.shortNepaliDay}</div>
                                                <div>({day.shortName})</div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {weeks.map((week, wi) => ( // Use the 'weeks' calculated for the current month
                                        <tr key={wi} className="">
                                            {week.map((day, di) =>
                                                day ? (
                                                    <td
                                                        style={{ height: "auto", width: "auto", border: `${day?.today ? "2px solid #126696" : ""}` }}
                                                        key={day.id}
                                                        tabIndex={0}
                                                        className={`${(day?.week_day === "Saturday" || day?.events.some(event => event.national_holiday === 1)) ? ` text-danger ${day?.week_day}` : ``}`}
                                                        aria-label={`${day.bs_d} ${currentMonthVal} ${currentYearVal}`}
                                                    >
                                                        <div className="d-flex flex-column justify-content-between"
                                                            style={{ height: "100%" }}
                                                        >
                                                            <p className="m-0 text-right mr-1" style={{ fontSize: "1.5vh", fontFamily: "'NepaliFont', Arial" }}>
                                                                {day.unicode?.bs_d || day.bs_d}
                                                            </p>
                                                            <div className="d-flex flex-column justify-content-center">
                                                                {uniqueCalendarEvents
                                                                    .filter(event => {
                                                                        const dayDate = moment(day.date_ad).startOf('day');
                                                                        const eventStart = moment(event.start, "YYYY-MM-DD").startOf('day');
                                                                        const eventEnd = event.end
                                                                            ? moment(event.end).startOf('day')
                                                                            : eventStart;
                                                                        return dayDate.isSameOrAfter(eventStart) && dayDate.isSameOrBefore(eventEnd);
                                                                    })
                                                                    .map((event, eventIndex) => (
                                                                        <div id={`toggle${event.id}`} key={event.id}>
                                                                            <div
                                                                                key={eventIndex} className="mt-1"
                                                                                style={{
                                                                                    backgroundColor: event.color,
                                                                                    borderRadius: "6px",
                                                                                    lineHeight: "1.4",
                                                                                    zIndex: "999999999"
                                                                                }}>
                                                                                <span className="text-left text-white" style={{ fontSize: "1.6vh" }}>
                                                                                    {event.title}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }

                                                            </div>
                                                            <span className="text-left" style={{
                                                                fontSize: "1.6vh"
                                                            }}>
                                                                {day.ad_d}
                                                            </span>
                                                        </div>
                                                    </td>
                                                ) : (
                                                    <td key={`blank-${wi}-${di}`} className="py-2 px-2" aria-hidden="true" />
                                                )
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div>


        </>
    )
}


export default DisplayAllNpCalendar;